import { render, staticRenderFns } from "./ComPort.vue?vue&type=template&id=b174c878&scoped=true&"
import script from "./ComPort.vue?vue&type=script&lang=js&"
export * from "./ComPort.vue?vue&type=script&lang=js&"
import style0 from "./ComPort.vue?vue&type=style&index=0&id=b174c878&lang=scss&scoped=true&"
import style1 from "./ComPort.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b174c878",
  null
  
)

export default component.exports